import React from 'react';
import { Card } from '../ui/Card';
import { Message, Task } from '../../types';
import { LineChart } from './charts/LineChart';
import { format, subDays, startOfDay, endOfDay } from 'date-fns';
import { motion } from 'framer-motion';

interface TimelineChartProps {
  messages: Message[];
  tasks: Task[];
}

export const TimelineChart: React.FC<TimelineChartProps> = ({ messages = [], tasks = [] }) => {
  const getTimelineData = () => {
    const days = 7;
    const timeline = [];
    const today = new Date();

    for (let i = days - 1; i >= 0; i--) {
      const date = subDays(today, i);
      const dayStart = startOfDay(date);
      const dayEnd = endOfDay(date);
      
      const dayMessages = messages.filter(msg => {
        const msgDate = new Date(msg.createdAt);
        return msgDate >= dayStart && msgDate <= dayEnd;
      });

      const dayTasks = tasks.filter(task => {
        const taskDate = new Date(task.createdAt);
        return taskDate >= dayStart && taskDate <= dayEnd;
      });

      timeline.push({
        date: format(date, 'EEE'),
        value: dayMessages.length + dayTasks.length
      });
    }

    return timeline;
  };

  const timelineData = getTimelineData();

  return (
    <Card className="p-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <LineChart
          title="Activity Timeline"
          data={timelineData}
          color="bg-blue-500"
        />
        <div className="mt-4 text-sm text-gray-600">
          <p>Combined messages and tasks over the past 7 days</p>
          {timelineData.every(d => d.value === 0) && (
            <p className="text-center mt-2 text-gray-500">No activity recorded in the past week</p>
          )}
        </div>
      </motion.div>
    </Card>
  );
};